import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    showLogin: false,
    leftWidth: 0,
    province:'',
    city:'',
    logoImgUrl:undefined,
    officialAccountsUrl:undefined,
  },
  getters: {
    showLogin: state => state.showLogin,
    leftWidth: state => state.leftWidth,
    province: state => state.province,
    city: state => state.city,
    logoImgUrl: state => state.logoImgUrl,
    officialAccountsUrl: state => state.officialAccountsUrl,
  },
  mutations: {
    setShowLogin: (state, value) => {
      state.showLogin = value;
    },
    setLeftWidth: (state, value) => {
      state.leftWidth = value;
    },
    setProvince: (state, value) => {
      state.province = value;
    },
    setCity: (state, value) => {
      state.city = value;
    },
    setLogoImgUrl: (state, value) => {
      state.logoImgUrl = value;
    },
    setOfficialAccounts: (state, value) => {
      state.officialAccountsUrl = value;
    },
  },
  actions: {
    SET_SHOWLOGIN({ commit }, status) {
      commit("setShowLogin", status);
    },
    SET_LEFTWIDTH({ commit }, status) {
      commit("setLeftWidth", status);
    },
    SET_PROVINCE({ commit }, status) {
      commit("setProvince", status);
    },
    SET_CITY({ commit }, status) {
      commit("setCity", status);
    },
    SET_LOGOIMGURL({ commit }, status) {
      commit("setLogoImgUrl", status);
    },
    SET_OFFICIALACCOUNTS({ commit }, status) {
      commit("setOfficialAccounts", status);
    },
  },
  modules: {},
});
